import { useAuthStore } from '@/stores/authStore'
import type { Role } from '@/types'
import { isHybridBdrCloser } from '@/utils/operationalUsers'

// Hook conveniente para acessar estado de autenticação
export function useAuth() {
  const { user, token, isAuthenticated, login, logout } = useAuthStore()

  const hasRole = (role: Role | Role[]): boolean => {
    if (!user) return false
    const needed = (Array.isArray(role) ? role : [role]).map((r) => r.toLowerCase())
    const userRoleLower = user.role.toLowerCase()
    if (needed.includes(userRoleLower)) return true
    if (isHybridBdrCloser(user.id)) {
      return needed.some((r) => r === 'bdr' || r === 'closer')
    }
    return false
  }

  const isAdmin = user?.role?.toLowerCase() === 'admin'

  return {
    user,
    token,
    isAuthenticated,
    isAdmin,
    hasRole,
    login,
    logout,
  }
}
